import { companyAreaReportsReducer } from "../reducer/CompanyAreaReportsReducer";

export const reducer = companyAreaReportsReducer;